<template lang="html">
  <div class="w-full md:w-1/3">
    <div class="md:flex text-center">
    <div class="bg-white mb-4 p-8 md:w-1/2 shadow-lg rounded text-4xl text-gray-600">
      <small class="text-xs block">Registered</small>
      <i class="fas fa-users"></i>
      <b class="ml-2">{{$attrs.count}}</b>
    </div>
    <div class="bg-white mb-4 md:ml-4 md:w-1/2 p-8 shadow-lg rounded text-4xl text-gray-600">
      <small class="text-xs block">Completed Heroes</small>
      <i class="fas fa-mask"></i>
      <b class="ml-2">{{countCompleted}}</b>
    </div>
  </div>
  <!-- Latest -->
  <div class="bg-white mt-8 p-4 shadow-lg rounded text-gray-700">
    <span class="mb-4 block border-b pb-4">
      <i class="fas fa-mask text-xl"></i>  <span class="text-xl">Heroes</span>
    </span>
    <input
    v-model="searchQueryHeroes"
    class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
    name="searchemail"
    placeholder="Search Heroes" />
    <LatestUsers
    v-for="(user,i) in filterHeros(herosCompleted)"
    v-bind:key="i"
    class="text-gray-700"
    :email="user.email"
    :role="user.role.name"
    :hero="user.hero"
    />
  </div>
  <div class="bg-white mt-8 mb-4 p-4 shadow-lg rounded">
    <span class="mb-4 block border-b pb-4 text-gray-700">
      <i class="fas fa-user-ninja text-xl"></i>  <span class="text-xl">All Registered</span>
    </span>
    <input
    v-model="searchQueryUsers"
    class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
    name="searchemail"
    placeholder="Search Users" />
    <LatestUsers
    v-for="(user,i) in filterUsers($attrs.users)"
    v-bind:key="i"
    class="text-heroyellow"
    :email="user.email"
    :role="user.role.name"
    />
  </div>
  </div>
</template>

<script>
  import LatestUsers from "@/components/admin/Latest.vue"
  import heros from "@/data/result/result.json"
  export default {
    components: {
      LatestUsers
    },
    data () {
      return {
        searchQueryHeroes: "",
        searchQueryUsers: "",
      }
    },
    methods: {
      heroConvert( id ) {
        var res = null
        heros.forEach(hero => {
          if(id == hero.id) {
            res = hero.title
          }
        });
        return res
      },
      filterHeros: function(Search) {
      var app = this;
      return Search.filter(function(Search) {
          let regex = new RegExp('(' + app.searchQueryHeroes + ')', 'i');
          //console.log(Search.email.match(regex))
          var Find = Search.email.match(regex);
          if(!Find) {
             Find = Search.hero.match(regex);
          }
          if(!Find) {
             Find = Search.role.name.match(regex);
          }
          return Find;
      })
    },
    filterUsers: function(Search) {
    var app = this;
    return Search.filter(function(Search) {
        let regex = new RegExp('(' + app.searchQueryUsers + ')', 'i');
        //console.log(Search.email.match(regex))
        var Find = Search.email.match(regex);
        if(!Find) {
           Find = Search.role.name.match(regex);
        }
        return Find;
    })
  },
    },
    computed: {
      herosCompleted() {
        let users = this.$attrs.users
        let heros = this.$attrs.heros
        let result = []
        users.forEach(user => {
          heros.forEach(hero => {
            if(hero.uid == user.uid){
              result.push({
                email: user.email,
                hero: this.heroConvert(hero.number),
                role: user.role
              })
            }
          });
        });
        return result
      },

      countCompleted() {
        var heros = this.$attrs.heros.length
        return heros
      }
    }
  }
</script>

<style lang="css">
</style>
